import Vuex from "vuex";
import Vue from "vue";
Vue.use(Vuex);
import axios from "axios";
export default new Vuex.Store({
  state: {
    alert: {},
    profile: {},
    route: null,

    currentPage: null,
    routingPermission: [],
    allList: [
      {
        action:
          '<svg width="12px" height="12px" viewBox="0 0 46 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>customer-support</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1717.000000, -291.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(1.000000, 0.000000)"><path class="color-background" d="M45,0 L26,0 C25.447,0 25,0.447 25,1 L25,20 C25,20.379 25.214,20.725 25.553,20.895 C25.694,20.965 25.848,21 26,21 C26.212,21 26.424,20.933 26.6,20.8 L34.333,15 L45,15 C45.553,15 46,14.553 46,14 L46,1 C46,0.447 45.553,0 45,0 Z" opacity="0.59858631"></path><path class="color-background" d="M22.883,32.86 C20.761,32.012 17.324,31 13,31 C8.676,31 5.239,32.012 3.116,32.86 C1.224,33.619 0,35.438 0,37.494 L0,41 C0,41.553 0.447,42 1,42 L25,42 C25.553,42 26,41.553 26,41 L26,37.494 C26,35.438 24.776,33.619 22.883,32.86 Z"></path><path class="color-background" d="M13,28 C17.432,28 21,22.529 21,18 C21,13.589 17.411,10 13,10 C8.589,10 5,13.589 5,18 C5,22.529 8.568,28 13,28 Z"></path></g></g></g></g></svg>',
        active: false,
        title: "Master",
        items: [
          {
            title: "Role",
            prefix: "R",
            key: "role",
            link: "/role",
          },
          {
            title: "App - module",
            prefix: "A",
            key: "application",
            link: "/application_module",
          },
          {
            title: "State",
            prefix: "S",
            key: "state",
            link: "/state",
          },
          {
            title: "Document",
            prefix: "C",
            key: "document",
            link: "/document",
          },

          {
            title: "Master State",
            prefix: "M",
            key: "master_state",
            link: "/master_state",
          },
          {
            title: "Master Action",
            prefix: "M",
            key: "master_action",
            link: "/master_action",
          },
          {
            title: "Auction Center",
            prefix: "A",
            key: "auction_center",
            link: "/auction_center",
          },
          {
            title: "Warehouse",
            prefix: "W",
            key: "ware_house",
            link: "/ware_house",
          },
          {
            title: "District",
            prefix: "D",
            key: "district",
            link: "/district",
          },
          {
            title: "Grade",
            prefix: "G",
            key: "grade",
            link: "/grade",
          },
          {
            title: "Items",
            prefix: "I",
            key: "items",
            link: "/items",
          },
          {
            title: "Competitor",
            prefix: "C",
            key: "competitor",
            link: "/competitor",
          },
          {
            title: "Broker",
            prefix: "B",
            key: "broker",
            link: "/broker",
          },
          {
            title: "Season",
            prefix: "S",
            key: "season",
            link: "/season",
          },
          {
            title: "Sale No",
            prefix: "S",
            key: "season_sale",
            link: "/season_sale",
          },
          {
            title: "Mark",
            prefix: "M",
            key: "mark",
            link: "/mark",
          },
          {
            title: "Certifcate",
            prefix: "C",
            key: "certificate",
            link: "/certificate",
          },
          {
            title: "Company Warehouse",
            prefix: "C",
            key: "company_ware_house",
            link: "/company_ware_house",
          },
          {
            title: "Tea Type",
            prefix: "T",
            key: "tea_type",
            link: "/tea_type",
          },
          {
            title: "Category",
            prefix: "c",
            key: "category",
            link: "/category",
          },
          {
            title: "Role Permissions",
            prefix: "c",
            key: "role_permission",
            link: "/role_permission",
          },
          {
            title: "Vendor",
            prefix: "v",
            key: "vendor",
            link: "/vendor",
          },
          {
            title: "User",
            prefix: "u",
            key: "user",
            link: "/user",
          },
          // {
          //   title: "Season Vendor Offer",
          //   prefix: "S",
          //   key: "season_vendor_offer",
          //   link: "/season-vendor-offer",
          // },
        ],
      },
      {
        // viewBox="0 0 20 20"
        action: `<svg width="12px" height="12px" viewBox="5 -8 30 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="text-dark mb-1"><title>megaphone</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2168.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(452.000000, 300.000000)"><path d="M35.7958333,0.273166667 C35.2558424,-0.0603712374 34.5817509,-0.0908856664 34.0138333,0.1925 L19.734,7.33333333 L9.16666667,7.33333333 C4.10405646,7.33333333 0,11.4373898 0,16.5 C0,21.5626102 4.10405646,25.6666667 9.16666667,25.6666667 L19.734,25.6666667 L34.0138333,32.8166667 C34.5837412,33.1014624 35.2606401,33.0699651 35.8016385,32.7334768 C36.3426368,32.3969885 36.6701539,31.8037627 36.6666942,31.1666667 L36.6666942,1.83333333 C36.6666942,1.19744715 36.3370375,0.607006911 35.7958333,0.273166667 Z" class="color-background"></path><path d="M38.5,11 L38.5,22 C41.5375661,22 44,19.5375661 44,16.5 C44,13.4624339 41.5375661,11 38.5,11 Z" opacity="0.601050967" class="color-background"></path><path d="M18.5936667,29.3333333 L10.6571667,29.3333333 L14.9361667,39.864 C15.7423448,41.6604248 17.8234451,42.4993948 19.6501416,41.764381 C21.4768381,41.0293672 22.3968823,38.982817 21.7341667,37.1286667 L18.5936667,29.3333333 Z" opacity="0.601050967" class="color-background"></path></g></g></g></g></svg>`,
        active: false,
        title: "Auction",
        items: [
          {
            title: "Catalogue",
            prefix: "C",
            key: "catalogue_upload",
            link: "/catalogue",
          },
          {
            title: "View Catalogue",
            prefix: "C",
            key: "catalogue_reference",
            link: "/view_catalogue",
          },
          {
            title: "Allocation",
            prefix: "C",
            key: "auction_allocation",
            link: "/auction_allocation",
          },
          {
            title: "My Allocation",
            prefix: "M",
            key: "auction_my_allocation",
            link: "/auction_my_allocation",
          },
          {
            title: "Allocation List",
            prefix: "A",
            key: "allocation_list",
            link: "/allocation_list",
          },
          {
            title: "My Comments",
            prefix: "M",
            key: "my_comments",
            link: "/my_comments",
          },
          {
            title: "Knockdown",
            prefix: "K",
            key: "auction_knockdown",
            link: "/auction_knockdown",
          },
          {
            title: "Knockdown List",
            prefix: "K",
            key: "auction_knockdown_list",
            link: "/auction_knockdown_list",
          },
          {
            title: "Contract Note",
            prefix: "C",
            key: "contract_note",
            link: "/contract_note",
          },
          {
            title: "History",
            prefix: "C",
            key: "auction_history",
            link: "/auction_history",
          },
          ,
        ],
      },
      {
        action: `<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>document</title>
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero">
          <g transform="translate(1716.000000, 291.000000)">
          <g transform="translate(154.000000, 300.000000)">
          <path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379"></path>
          <path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"></path>
          </g></g></g></g></svg>`,
        active: false,
        title: "Private Sale",
        items: [
          {
            title: "Offers",
            prefix: "O",
            key: "private_allocation",
            link: "/private_allocation",
          },
          {
            title: "My Allocation",
            prefix: "M",
            key: "my_private_allocation",
            link: "/my_private_allocation",
          },
          {
            title: "My Bids",
            prefix: "M",
            key: "my_bids",
            link: "/my_bids",
          },
          {
            title: "PO Generation",
            prefix: "P",
            key: "private_po_generation",
            link: "/po_generation",
          },
          {
            title: "PO Confirmation",
            prefix: "P",
            key: "po_confirmation",
            link: "/po_confirmation",
          },
          // {
          //   title: "PO Close",
          //   prefix: "P",
          //   key: "close_po",
          //   link: "/po_close",
          // },
          ,
        ],
      },
      {
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>spaceship</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M39.3,0.706666667 C38.9660984,0.370464027 38.5048767,0.192278529 38.0316667,0.216666667 C14.6516667,1.43666667 6.015,22.2633333 5.93166667,22.4733333 C5.68236407,23.0926189 5.82664679,23.8009159 6.29833333,24.2733333 L15.7266667,33.7016667 C16.2013871,34.1756798 16.9140329,34.3188658 17.535,34.065 C17.7433333,33.98 38.4583333,25.2466667 39.7816667,1.97666667 C39.8087196,1.50414529 39.6335979,1.04240574 39.3,0.706666667 Z M25.69,19.0233333 C24.7367525,19.9768687 23.3029475,20.2622391 22.0572426,19.7463614 C20.8115377,19.2304837 19.9992882,18.0149658 19.9992882,16.6666667 C19.9992882,15.3183676 20.8115377,14.1028496 22.0572426,13.5869719 C23.3029475,13.0710943 24.7367525,13.3564646 25.69,14.31 C26.9912731,15.6116662 26.9912731,17.7216672 25.69,19.0233333 L25.69,19.0233333 Z"></path><path class="color-background" d="M1.855,31.4066667 C3.05106558,30.2024182 4.79973884,29.7296005 6.43969145,30.1670277 C8.07964407,30.6044549 9.36054508,31.8853559 9.7979723,33.5253085 C10.2353995,35.1652612 9.76258177,36.9139344 8.55833333,38.11 C6.70666667,39.9616667 0,40 0,40 C0,40 0,33.2566667 1.855,31.4066667 Z"></path><path class="color-background" d="M17.2616667,3.90166667 C12.4943643,3.07192755 7.62174065,4.61673894 4.20333333,8.04166667 C3.31200265,8.94126033 2.53706177,9.94913142 1.89666667,11.0416667 C1.5109569,11.6966059 1.61721591,12.5295394 2.155,13.0666667 L5.47,16.3833333 C8.55036617,11.4946947 12.5559074,7.25476565 17.2616667,3.90166667 L17.2616667,3.90166667 Z" opacity="0.598539807"></path><path class="color-background" d="M36.0983333,22.7383333 C36.9280725,27.5056357 35.3832611,32.3782594 31.9583333,35.7966667 C31.0587397,36.6879974 30.0508686,37.4629382 28.9583333,38.1033333 C28.3033941,38.4890431 27.4704606,38.3827841 26.9333333,37.845 L23.6166667,34.53 C28.5053053,31.4496338 32.7452344,27.4440926 36.0983333,22.7383333 L36.0983333,22.7383333 Z" opacity="0.598539807"></path></g></g></g></g></svg>',
        active: false,
        title: "Transfer",
        items: [
          {
            title: "Internal Transfer",
            prefix: "I",
            key: "internal_transfer",
            link: "/internal_transfer",
          },
          {
            title: "History",
            prefix: "H",
            key: "internal_transfer_history",
            link: "/internal_transfer_history",
          },
          //   {
          //     title: "Internal Dispatch",
          //     prefix: "I",
          //     key: "internal_dispatch",
          //     link: "/internal_dispatch",
          //   },
          //   {
          //     title: "Internal RM Arrival",
          //     prefix: "I",
          //     key: "internal_rm_arrival",
          //     link: "/iternal_rm_arrival",
          //   },
          //   {
          //     title: "Internal Delivery Notes",
          //     prefix: "I",
          //     key: "internal_delivery_notes",
          //     link: "/internal_delivery_notes",
          //   },
          //   ,
        ],
      },
      {
        action:
          '<svg class="text-dark" width="12px" height="12px" viewBox="0 0 42 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>basket</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1869.000000, -741.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g id="basket" transform="translate(153.000000, 450.000000)"><path class="color-background" d="M34.080375,13.125 L27.3748125,1.9490625 C27.1377583,1.53795093 26.6972449,1.28682264 26.222716,1.29218729 C25.748187,1.29772591 25.3135593,1.55890827 25.0860125,1.97535742 C24.8584658,2.39180657 24.8734447,2.89865282 25.1251875,3.3009375 L31.019625,13.125 L10.980375,13.125 L16.8748125,3.3009375 C17.1265553,2.89865282 17.1415342,2.39180657 16.9139875,1.97535742 C16.6864407,1.55890827 16.251813,1.29772591 15.777284,1.29218729 C15.3027551,1.28682264 14.8622417,1.53795093 14.6251875,1.9490625 L7.919625,13.125 L0,13.125 L0,18.375 L42,18.375 L42,13.125 L34.080375,13.125 Z" opacity="0.595377604"></path><path class="color-background" d="M3.9375,21 L3.9375,38.0625 C3.9375,40.9619949 6.28800506,43.3125 9.1875,43.3125 L32.8125,43.3125 C35.7119949,43.3125 38.0625,40.9619949 38.0625,38.0625 L38.0625,21 L3.9375,21 Z M14.4375,36.75 L11.8125,36.75 L11.8125,26.25 L14.4375,26.25 L14.4375,36.75 Z M22.3125,36.75 L19.6875,36.75 L19.6875,26.25 L22.3125,26.25 L22.3125,36.75 Z M30.1875,36.75 L27.5625,36.75 L27.5625,26.25 L30.1875,26.25 L30.1875,36.75 Z"></path></g></g></g></g></svg>',
        active: false,
        title: "Delivery Order",
        items: [
          {
            title: "Delivery Order",
            prefix: "D",
            key: "dispatch",
            link: "/dispatch",
          },
          // {
          //   title: "RM Arrival",
          //   prefix: "U",
          //   key: "rm_arrival",
          //   link: "/rm_arrival",
          // },
          // {
          //   title: "Delivery Notes",
          //   prefix: "D",
          //   key: "delivery_notes",
          //   link: "/delivery_notes",
          // },
          {
            title: "History",
            prefix: "H",
            key: "dispatch_history",
            link: "/dispatch_history",
          },
          {
            title: "RM-Upload",
            prefix: "R",
            key: "rm_upload",
            link: "/rm_upload",
          },
          ,
        ],
      },

      {
        action:
          '<svg width="12px" height="12px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>office</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1869.000000, -293.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g id="office" transform="translate(153.000000, 2.000000)"><path class="color-background" d="M12.25,17.5 L8.75,17.5 L8.75,1.75 C8.75,0.78225 9.53225,0 10.5,0 L31.5,0 C32.46775,0 33.25,0.78225 33.25,1.75 L33.25,12.25 L29.75,12.25 L29.75,3.5 L12.25,3.5 L12.25,17.5 Z" opacity="0.6"></path><path class="color-background" d="M40.25,14 L24.5,14 C23.53225,14 22.75,14.78225 22.75,15.75 L22.75,38.5 L19.25,38.5 L19.25,22.75 C19.25,21.78225 18.46775,21 17.5,21 L1.75,21 C0.78225,21 0,21.78225 0,22.75 L0,40.25 C0,41.21775 0.78225,42 1.75,42 L40.25,42 C41.21775,42 42,41.21775 42,40.25 L42,15.75 C42,14.78225 41.21775,14 40.25,14 Z M12.25,36.75 L7,36.75 L7,33.25 L12.25,33.25 L12.25,36.75 Z M12.25,29.75 L7,29.75 L7,26.25 L12.25,26.25 L12.25,29.75 Z M35,36.75 L29.75,36.75 L29.75,33.25 L35,33.25 L35,36.75 Z M35,29.75 L29.75,29.75 L29.75,26.25 L35,26.25 L35,29.75 Z M35,22.75 L29.75,22.75 L29.75,19.25 L35,19.25 L35,22.75 Z"></path></g></g></g></g></svg>',
        active: false,
        title: "QC & QA",
        items: [
          {
            title: "IRMC",
            prefix: "I",
            key: "irmc",
            link: "/irmc",
          },
          {
            title: "Vendor Evaluation",
            prefix: "V",
            key: "vendor_evaluation",
            link: "/vendor_evaluation",
          },
          {
            title: "Purchase Weigh up Tasting",
            prefix: "P",
            key: "pw_tasting",
            link: "/purchase_weigh_up_tasting",
          },
          {
            title: "Independent Tasting",
            prefix: "I",
            key: "independent_weigh_up_tasting",
            link: "/independent_weigh_up_tasting",
          },
          {
            title: "Blend Weigh up Tasting",
            prefix: "B",
            key: "blend_sheet_tasting",
            link: "/blend_sheet_tasting",
          },

          // {
          //   title: "Density Upload",
          //   prefix: "D",
          //   key: "density_upload",
          //   link: "/density_upload",
          // },
          {
            title: "CSTR",
            prefix: "C",
            key: "cstr",
            link: "/cstr",
          },
          {
            title: "ITDI",
            prefix: "I",
            key: "itdi",
            link: "/itdiList",
          },
        ],
      },
      {
        action:
          '<svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>credit-card</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(453.000000, 454.000000)"><path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path><path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path></g></g></g></g></svg>',
        active: false,
        title: "GRN",
        items: [
          {
            title: "GRN",
            prefix: "I",
            key: "grn_tasting",
            link: "/grn",
          },
        ],
      },
      // {
      //   action:
      //     '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>spaceship</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1720.000000, -592.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(4.000000, 301.000000)"><path class="color-background" d="M39.3,0.706666667 C38.9660984,0.370464027 38.5048767,0.192278529 38.0316667,0.216666667 C14.6516667,1.43666667 6.015,22.2633333 5.93166667,22.4733333 C5.68236407,23.0926189 5.82664679,23.8009159 6.29833333,24.2733333 L15.7266667,33.7016667 C16.2013871,34.1756798 16.9140329,34.3188658 17.535,34.065 C17.7433333,33.98 38.4583333,25.2466667 39.7816667,1.97666667 C39.8087196,1.50414529 39.6335979,1.04240574 39.3,0.706666667 Z M25.69,19.0233333 C24.7367525,19.9768687 23.3029475,20.2622391 22.0572426,19.7463614 C20.8115377,19.2304837 19.9992882,18.0149658 19.9992882,16.6666667 C19.9992882,15.3183676 20.8115377,14.1028496 22.0572426,13.5869719 C23.3029475,13.0710943 24.7367525,13.3564646 25.69,14.31 C26.9912731,15.6116662 26.9912731,17.7216672 25.69,19.0233333 L25.69,19.0233333 Z"></path><path class="color-background" d="M1.855,31.4066667 C3.05106558,30.2024182 4.79973884,29.7296005 6.43969145,30.1670277 C8.07964407,30.6044549 9.36054508,31.8853559 9.7979723,33.5253085 C10.2353995,35.1652612 9.76258177,36.9139344 8.55833333,38.11 C6.70666667,39.9616667 0,40 0,40 C0,40 0,33.2566667 1.855,31.4066667 Z"></path><path class="color-background" d="M17.2616667,3.90166667 C12.4943643,3.07192755 7.62174065,4.61673894 4.20333333,8.04166667 C3.31200265,8.94126033 2.53706177,9.94913142 1.89666667,11.0416667 C1.5109569,11.6966059 1.61721591,12.5295394 2.155,13.0666667 L5.47,16.3833333 C8.55036617,11.4946947 12.5559074,7.25476565 17.2616667,3.90166667 L17.2616667,3.90166667 Z" opacity="0.598539807"></path><path class="color-background" d="M36.0983333,22.7383333 C36.9280725,27.5056357 35.3832611,32.3782594 31.9583333,35.7966667 C31.0587397,36.6879974 30.0508686,37.4629382 28.9583333,38.1033333 C28.3033941,38.4890431 27.4704606,38.3827841 26.9333333,37.845 L23.6166667,34.53 C28.5053053,31.4496338 32.7452344,27.4440926 36.0983333,22.7383333 L36.0983333,22.7383333 Z" opacity="0.598539807"></path></g></g></g></g></svg>',
      //   active: false,
      //   title: "Purchase Weigh up Tasting",
      //   items: [
      //     {
      //       title: "Purchase Weigh up Tasting",
      //       prefix: "I",
      //       key: "pw_tasting",
      //       link: "/purchase_weigh_up_tasting",
      //     },
      //   ],
      // },

      {
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>document</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(154.000000, 300.000000)"><path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379"></path><path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"></path></g></g></g></g></svg>',
        active: false,
        title: "Reports",
        items: [
          {
            title: "Purchase Report",
            prefix: "P",
            key: "purchase_report",
            link: "/purchase_report",
          },
          {
            title: "PO Stock",
            prefix: "P",
            key: "po_stock",
            link: "/po_stock",
          },
          {
            title: "Item wise Report",
            prefix: "I",
            key: "itemwise_report",
            link: "/itemwise_report",
          },

          // {
          //   title: "Season wise",
          //   prefix: "S",
          //   key: "season_wise",
          //   link: "/season_wise",
          // },
          {
            title: "Buying Tracking Report",
            prefix: "B",
            key: "buying_tracking",
            link: "/buying_tracking",
          },
          {
            title: "Buying Tracking Report (Private)",
            prefix: "B",
            key: "buying_tracking_pvt",
            link: "/buying_tracking_pvt",
          },
          // {
          //   title: "Miscellaneous",
          //   prefix: "M",
          //   key: "miscellaneous",
          //   link: "/miscellaneous",
          // },
        ],
      },
      {
        action:
          '<svg width="12px" height="12px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>settings</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-2020.000000, -442.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(304.000000, 151.000000)"><polygon class="color-background" opacity="0.596981957" points="18.0883333 15.7316667 11.1783333 8.82166667 13.3333333 6.66666667 6.66666667 0 0 6.66666667 6.66666667 13.3333333 8.82166667 11.1783333 15.315 17.6716667"></polygon><path class="color-background" d="M31.5666667,23.2333333 C31.0516667,23.2933333 30.53,23.3333333 30,23.3333333 C29.4916667,23.3333333 28.9866667,23.3033333 28.48,23.245 L22.4116667,30.7433333 L29.9416667,38.2733333 C32.2433333,40.575 35.9733333,40.575 38.275,38.2733333 L38.275,38.2733333 C40.5766667,35.9716667 40.5766667,32.2416667 38.275,29.94 L31.5666667,23.2333333 Z" opacity="0.596981957"></path><path class="color-background" d="M33.785,11.285 L28.715,6.215 L34.0616667,0.868333333 C32.82,0.315 31.4483333,0 30,0 C24.4766667,0 20,4.47666667 20,10 C20,10.99 20.1483333,11.9433333 20.4166667,12.8466667 L2.435,27.3966667 C0.95,28.7083333 0.0633333333,30.595 0.00333333333,32.5733333 C-0.0583333333,34.5533333 0.71,36.4916667 2.11,37.89 C3.47,39.2516667 5.27833333,40 7.20166667,40 C9.26666667,40 11.2366667,39.1133333 12.6033333,37.565 L27.1533333,19.5833333 C28.0566667,19.8516667 29.01,20 30,20 C35.5233333,20 40,15.5233333 40,10 C40,8.55166667 39.685,7.18 39.1316667,5.93666667 L33.785,11.285 Z"></path></g></g></g></g></svg>',
        active: false,
        title: "Blend",
        items: [
          {
            title: "Category",
            prefix: "C",
            key: "blend_category",
            link: "/blend_category",
          },
          {
            title: "Code",
            prefix: "C",
            key: "blend_code",
            link: "/blend_code",
          },
          {
            title: "Type",
            prefix: "T",
            key: "blend_type",
            link: "/blend_type",
          },
          {
            title: "Recipe",
            prefix: "R",
            key: "blend_recipe",
            link: "/blend_recipe",
          },
          {
            title: "RM Requisition",
            prefix: "R",
            key: "rm_requisition",
            link: "/rm_requisition",
          },
          {
            title: "Provisional Plan",
            prefix: "P",
            key: "provisional_plan",
            link: "/provisional_plan",
          },
          {
            title: "Blend Sheet",
            prefix: "B",
            key: "blendSheet",
            link: "/blendSheet",
          },
          {
            title: "MO",
            prefix: "M",
            key: "mo",
            link: "/mo",
          },
        ],
      },
      {
        action:
          '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        active: false,
        title: "Inventory",
        items: [
          {
            title: "Inventory",
            prefix: "C",
            key: "inventory",
            link: "/inventory",
          },
        ],
      },
      {
        action:
          '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" width="30px" height="30px" viewBox="0 0 55 10"><path d="M8.5,20.003l-2.834-5.669L-.003,11.5l5.669-2.834,2.834-5.669,2.834,5.669,5.669,2.834-5.669,2.834-2.834,5.669ZM2.233,11.5l4.178,2.089,2.089,4.178,2.089-4.178,4.178-2.089-4.178-2.089-2.089-4.178-2.089,4.178-4.178,2.089Zm16.267,12.489l-1.826-3.651-3.651-1.826,3.651-1.825,1.826-3.652,1.826,3.652,3.651,1.825-3.651,1.826-1.826,3.651Zm-3.241-5.477l2.161,1.081,1.08,2.161,1.08-2.161,2.161-1.081-2.161-1.08-1.08-2.161-1.08,2.161-2.161,1.08Zm4.254-9.497l-1.497-2.994-2.993-1.496,2.993-1.497L19.513,.036l1.497,2.994,2.993,1.497-2.993,1.496-1.497,2.994Zm-2.254-4.49l1.503,.751,.751,1.502,.751-1.502,1.503-.751-1.503-.751-.751-1.502-.751,1.502-1.503,.751Z"/></svg>',
        active: false,
        title: "Misc",
        items: [
          {
            title: "Batch Crawler",
            prefix: "B",
            key: "batch_track",
            link: "/batch_track",
          },
          {
            title: "Po Details",
            prefix: "P",
            key: "po_details",
            link: "/po_details",
          },
        ],
      },
      {
        action:
          '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" width="30px" height="30px" viewBox="0 0 55 10"><path d="M8.5,20.003l-2.834-5.669L-.003,11.5l5.669-2.834,2.834-5.669,2.834,5.669,5.669,2.834-5.669,2.834-2.834,5.669ZM2.233,11.5l4.178,2.089,2.089,4.178,2.089-4.178,4.178-2.089-4.178-2.089-2.089-4.178-2.089,4.178-4.178,2.089Zm16.267,12.489l-1.826-3.651-3.651-1.826,3.651-1.825,1.826-3.652,1.826,3.652,3.651,1.825-3.651,1.826-1.826,3.651Zm-3.241-5.477l2.161,1.081,1.08,2.161,1.08-2.161,2.161-1.081-2.161-1.08-1.08-2.161-1.08,2.161-2.161,1.08Zm4.254-9.497l-1.497-2.994-2.993-1.496,2.993-1.497L19.513,.036l1.497,2.994,2.993,1.497-2.993,1.496-1.497,2.994Zm-2.254-4.49l1.503,.751,.751,1.502,.751-1.502,1.503-.751-1.503-.751-.751-1.502-.751,1.502-1.503,.751Z"/></svg>',
        active: false,
        title: "Purchase Request",
        items: [
          {
            title: "Purchase Request",
            prefix: "PR",
            key: "purchase_request",
            link: "/purchase_request",
          },
          {
            title: "Blend Ratio",
            prefix: "BR",
            key: "blend_ratio",
            link: "/blend_ratio",
          },
        ],
      },
    ],
  },

  mutations: {
    SET_ROUTE(state, route) {
      state.route = route;
    },
    UPDATE_ROUTING_PERMISSIONS(state, data) {
      state.routingPermission = [];

      state.allList.map((master, index) => {
        master.items.map((item) => {
          let permission_array = data.findIndex((q) => {
            return q.key === item.key;
          });

          if (permission_array > -1) {
            // Check whether the page is current page? if then,  setting current page for the use of page permissions

            if (`/${data[permission_array].key}` === state.route.path || data[permission_array].key === state.route.path) {
              state.currentPage = data[permission_array];
            }
            // Adding outer array if not exist
            let index_of_outer = state.routingPermission.findIndex((a) => {
              return master.title === a.title;
            });

            if (index_of_outer === -1) {
              state.routingPermission.push({
                action: master.action,
                active: master.active,
                title: master.title,
                items: [item],
              });
            } else {
              state.routingPermission[index_of_outer].items.indexOf(item) === -1
                ? state.routingPermission[index_of_outer].items.push(item)
                : console.log("This item already exists");
            }
          }
        });
      });
      // console.log("ROUTING PERMISSIONS ", state.routingPermission);
      let index_of_selected = state.routingPermission.findIndex((a) => {
        console.log("CLICK", state.route.meta.groupName, a.title);
        return state.route.meta.groupName === a.title;
      });

      if (index_of_selected === -1) {
        console.error("Permission not allowed for this page / not added in backend");
      } else {
        state.routingPermission[index_of_selected].active = true;
      }

      // TODO : DELETE FOLLOWING .... Just for testing
      // let itm = {
      //   title: "Role Permissions",
      //   prefix: "c",
      //   key: "role_permission",
      //   link: "/role_permission",
      // };
      // state.routingPermission[0].items.indexOf(itm) === -1
      //   ? state.routingPermission[0].items.push(itm)
      //   : console.log("This item already exists");

      // state.routingPermission.push({
      //   action:
      //     '<svg width="12px" height="12px" viewBox="0 0 40 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>document</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1870.000000, -591.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(154.000000, 300.000000)"><path class="color-background" d="M40,40 L36.3636364,40 L36.3636364,3.63636364 L5.45454545,3.63636364 L5.45454545,0 L38.1818182,0 C39.1854545,0 40,0.814545455 40,1.81818182 L40,40 Z" opacity="0.603585379"></path><path class="color-background" d="M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z"></path></g></g></g></g></svg>',
      //   active: false,
      //   title: "Reports",
      //   items: [
      //     {
      //       title: "Purchase Report",
      //       prefix: "P",
      //       key: "purchase_report",
      //       link: "/purchase_report",
      //     },
      //   ],
      // });
      // TODO : END DELETE .... Just for testing
      window.localStorage.setItem("routingPermission", state.routingPermission);
    },
  },
  actions: {
    addRoutingPermissions({ commit, state }) {
      // if (state.routingPermission.length === 0) {
      axios
        .get("role/application-module/rolewise")
        .then((res) => {
          commit("UPDATE_ROUTING_PERMISSIONS", res.data);
        })
        .catch((err) => {
          console.log(err);
        });
      // }
    },
  },
  getters: {
    getProfile: function (state) {
      return state.profile;
    },
    getRoutingPermission: function (state) {
      return state.routingPermission;
    },
    getCurrentPage(state) {
      return state.currentPage;
    },
    getAlert: function (state) {
      return state.alert;
    },
  },
});
